import { Component, inject, OnInit, ChangeDetectorRef, Input } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table'
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon'
import { MatExpansionModule } from '@angular/material/expansion'
import { ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatMenuModule } from '@angular/material/menu'
import { MatInputModule } from '@angular/material/input'
import { MatFormField } from '@angular/material/input';
import { MatDividerModule } from '@angular/material/divider'
import { MatChipsModule } from '@angular/material/chips'
import { MatTooltipModule } from '@angular/material/tooltip';
import { AsyncPipe, CommonModule, DatePipe, TitleCasePipe } from '@angular/common';
import { map, Observable, shareReplay, Subscription, take } from 'rxjs';
import { AppointmentComponent } from '../appointment/appointment.component';
import { EncounterServiceService } from '../patient-wrapper/encounter-service.service';
import { AppointmentUiComponent } from '../appointment-ui/appointment-ui.component';
import { DashboardAppointmentSummary, DashboardTaskSummary, DoctorDashboardService, PendingDiagnosisSummary, TodaysActivitySummary } from './doctor-dashboard.service';
import { commonImports } from '../shared/table-interface';
import { ScrolldDirective } from '../scrolld.directive';
import { ReferenceDisplayDirective } from '../shared/reference-display.directive';
import { UpcomingActivitiesComponent } from '../unified-activities/upcoming-activities.component';
import { RemoteDoctorService } from '../remote-doctor/services/remote-doctor.service';
import { AuthService } from '../shared/auth/auth.service';


@Component({
  selector: 'app-doctors-dashboard',
  imports: [...commonImports,
    MatFormField, DatePipe, RouterLink,
    RouterLinkActive, AppointmentComponent,
    MatExpansionModule, MatCheckboxModule, TitleCasePipe,
    MatTableModule, AsyncPipe,
    MatChipsModule,
    MatInputModule, AppointmentUiComponent,
    UpcomingActivitiesComponent,
    MatMenuModule, ScrolldDirective, ReferenceDisplayDirective,
    MatTableModule, MatIconModule, MatTooltipModule, ReactiveFormsModule],
  templateUrl: './doctors-dashboard.component.html',
  styleUrls: ['../admin-dashboard/admin-dashboard.component.scss', './doctors-dashboard.component.scss']
})
export class DoctorsDashboardComponent implements OnInit {
  @Input() isConsultant: boolean = false;
  private doctorService = inject(DoctorDashboardService);
  private router = inject(Router);
  private cd = inject(ChangeDetectorRef);
 private auth = inject(AuthService); 
  private remoteDoctorService = inject(RemoteDoctorService);
  todaysPatients$: Observable<number> = this.doctorService.getTodaysPatientsCount$();
  pendingDiagnosisSummary$: Observable<PendingDiagnosisSummary> = this.doctorService.getPendingDiagnosisSummary$().pipe(
    shareReplay({ bufferSize: 1, refCount: true })
  );
  pendingDiagnosis$: Observable<number> = this.pendingDiagnosisSummary$.pipe(map(summary => summary.count));
  consultationAppointments$: Observable<number> = this.doctorService.getConsultationAppointmentsCount$();
  telemedicineAppointments$: Observable<number> = this.doctorService.getTelemedicineAppointmentsCount$();
  todaysActivitySummary$: Observable<TodaysActivitySummary> = this.doctorService.getTodaysActivitySummary$();
  nextAppointments$: Observable<DashboardAppointmentSummary[]> = this.doctorService.getNextAppointmentsForCurrentPractitioner$(3);
  nextTasks$: Observable<DashboardTaskSummary[]> = this.doctorService.getNextTasksForCurrentUser$(3);
  isGlobalRemoteDoctor = false;
  currentHospitalName: string | null = null;
  private userSub?: Subscription;
 ngOnInit(): void {
  this.userSub = this.auth.user.subscribe(user => {
    if (!user) {
      this.isGlobalRemoteDoctor = false;
      this.currentHospitalName = null;
      return;
    }

    const roles = user.roles || [];
    this.isGlobalRemoteDoctor = roles.includes('remotedoctor') && !!user.isGlobal;

    if (!this.isGlobalRemoteDoctor) {
      this.currentHospitalName = null;
      return;
    }

    if (user.activeHospitalName) {
      this.currentHospitalName = user.activeHospitalName;
    } else if (!this.currentHospitalName) {
      // fallback only if login didn't already give us a name
      this.loadCurrentHospitalName();
    }
  });
}

  navigateToAppointments(): void {
    this.router.navigate(['/app/appointments'], {
      queryParams: {
        serviceCategory: this.isConsultant ? 'consultation' : 'telemedicine',
        dateRange: 'Today'
      }
    });
  }

  navigateToPatients(): void {
    this.router.navigate(['/app/patients'], {
      queryParams: {
        encounter: 'active'
      }
    });
  }

  navigateToTasks(): void {
    this.router.navigate(['/app/tasks']);
  }
navigateToRemoteDoctorDashboard(): void {
  this.router.navigate(['/app/remote-doctor/my-hospitals']).then(success => {
    console.log('Navigation succeeded?', success);
  });
}
  navigateToPendingDiagnosis(): void {
    this.pendingDiagnosisSummary$.pipe(take(1)).subscribe(summary => {
      if (summary.firstPatientId) {
        this.router.navigate(['/app/patients', summary.firstPatientId, 'diagnosis'],
        //    {
        //   queryParams: summary.firstEncounterId ? { encounterId: summary.firstEncounterId } : undefined
        // }
      );
        return;
      }

      this.router.navigate(['/app/patients']);
    });
  }

 private loadCurrentHospitalName(): void {
    this.remoteDoctorService.getMyActiveHospitals().subscribe({
      next: (res) => {
        const current = res.hospitals.find(h => h.isCurrent);
        this.currentHospitalName = current?.hospitalName ?? null;
        this.cd.markForCheck();
      },
      error: (err) => {
        this.currentHospitalName = null;
        console.error('Failed to load current hospital name', err);
      }
    });
  }
    ngOnDestroy(): void {
    this.userSub?.unsubscribe();
  }
}
